import {
  FREQUENCY_MONTHLY,
  FREQUENCY_WEEKLY,
  FREQUENCY_BI_MONTHLY,
  FREQUENCY_ONE_PAYMENT,
  APPLY_ON_COST_PER_HOUR,
  APPLY_ON_FIXED_PER_PERSON,
  APPLY_ON_FIXED_PER_HOUR,
  APPLY_ON_FIXED_PER_DAY,
  APPLY_ON_ESTIMATED_PER_PERSON,
  APPLY_ON_ESTIMATED_PER_HOUR,
  APPLY_ON_ESTIMATED_PER_DAY
} from '../../constants/costs';

// Prices always come formatted for monthly payments, except for hourly/daily/per-person costs
export const FREQUENCY_PRICE_DICTIONARY = {
  // frequency-based labels
  [FREQUENCY_MONTHLY]: 'price.per.month',
  [APPLY_ON_COST_PER_HOUR]: 'price.per.hour',
  [FREQUENCY_WEEKLY]: 'price.per.month',
  [FREQUENCY_BI_MONTHLY]: 'price.per.month',
  // applyOn-based labels
  [APPLY_ON_FIXED_PER_PERSON]: 'price.per.person',
  [APPLY_ON_FIXED_PER_HOUR]: 'price.per.hour',
  [APPLY_ON_FIXED_PER_DAY]: 'price.per.day',
  [APPLY_ON_ESTIMATED_PER_PERSON]: 'price.per.person',
  [APPLY_ON_ESTIMATED_PER_HOUR]: 'price.per.hour',
  [APPLY_ON_ESTIMATED_PER_DAY]: 'price.per.day'
};

export const FREQUENCY_DICTIONARY = {
  [FREQUENCY_ONE_PAYMENT]: 'payment.timeline.frequency.onePayment',
  [FREQUENCY_MONTHLY]: 'payment.timeline.frequency.monthly',
  [FREQUENCY_WEEKLY]: 'payment.timeline.frequency.monthly',
  [FREQUENCY_BI_MONTHLY]: 'payment.timeline.frequency.monthly'
};

export const ICONS_DICTIONARY = {
  contractRegistration: 'check_circle_transparent',
  latePayment: 'verified_card',
  earlyDepartureNoticePeriodBroken: 'event_busy',
  extraTenant: 'perfect_for_couples',
  overnightGuest: 'perfect_for_couples',
  petFee: 'pets_allowed',
  outOfHoursCheckIn: 'faster',
  outOfHoursCheckOut: 'faster',
  checkOutCleaning: 'cleaning_service',
  council: 'bank_court_house',
  local: 'private_landlord',
  building: 'cottage',
  laundry: 'washing_machine',
  streaming: 'tv',
  custom: 'diamond',
  periodicCleaning: 'cleaning_service',
  parking: 'private_parking',
  bedLinen: 'bed_linen',
  meal: 'meal_service'
};

export default {
  FREQUENCY_PRICE_DICTIONARY,
  FREQUENCY_DICTIONARY,
  ICONS_DICTIONARY
};
